import { get } from 'lodash/fp';
import { OrderItemType } from '@mews-commander/data-access';
import { OrderItem } from '@mews-commander/types';

const getProductId = get<OrderItem, 'productId'>('productId');
const getServiceOrderId = get<OrderItem, 'serviceOrderId'>('serviceOrderId');
const getNotes = get<OrderItem, 'notes'>('notes');

export const mapTypeToGroupingFunc: Record<OrderItemType, (arg: OrderItem) => string | null> = {
    [OrderItemType.AdditionalExpenseRebate]: getServiceOrderId,
    [OrderItemType.CancellationFee]: getServiceOrderId,
    [OrderItemType.CityTax]: getServiceOrderId,
    [OrderItemType.CityTaxDiscount]: getServiceOrderId,
    [OrderItemType.CustomItem]: getNotes,
    [OrderItemType.Deposit]: getServiceOrderId,
    [OrderItemType.ExchangeRateDifference]: getServiceOrderId,
    [OrderItemType.NightRebate]: getServiceOrderId,
    [OrderItemType.ProductOrder]: getProductId,
    [OrderItemType.ProductOrderRebate]: getServiceOrderId,
    [OrderItemType.ServiceCharge]: getServiceOrderId,
    [OrderItemType.SpaceOrder]: getServiceOrderId,
    [OrderItemType.Surcharge]: getServiceOrderId,
    [OrderItemType.MulticurrencyFee]: getServiceOrderId,
    [OrderItemType.TaxCorrection]: getServiceOrderId,
    [OrderItemType.ResourceUpgradeFee]: getServiceOrderId,
    [OrderItemType.InvoiceFee]: getServiceOrderId,
    [OrderItemType.AllowanceDiscount]: getProductId,
    [OrderItemType.AllowanceBreakage]: getProductId,
    [OrderItemType.AllowanceContraBreakage]: getProductId,
};
